import { render, staticRenderFns } from "./gameList.vue?vue&type=template&id=d83f2c4a&scoped=true&"
import script from "./gameList.vue?vue&type=script&lang=js&"
export * from "./gameList.vue?vue&type=script&lang=js&"
import style0 from "./gameList.vue?vue&type=style&index=0&id=d83f2c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83f2c4a",
  null
  
)

export default component.exports